const maskDirective = {
  mounted(el, binding) {
    const input = el.querySelector('input') || el
    const pattern = binding.value
    const format = (value) => {
      if (!pattern) return value
      const digits = String(value || '').replace(/\D/g, '')
      let di = 0
      let out = ''
      for (let i = 0; i < pattern.length; i += 1) {
        const p = pattern[i]
        if (p === '#') {
          if (di >= digits.length) break
          out += digits[di]
          di += 1
        } else {
          out += p
        }
      }
      return out
    }
    const handler = (e) => {
      const formatted = format(e.target.value)
      if (formatted === e.target.value) return
      e.target.value = formatted
      e.target.dispatchEvent(new Event('input', { bubbles: true }))
    }
    input._maskHandler = handler
    input.addEventListener('input', handler)
    // initial format
    if (input.value) handler({ target: input })
  },
  updated(el, binding) {
    const input = el.querySelector('input') || el
    if (!input || !input._maskHandler) return
    if (binding.value === binding.oldValue) return
    // reformat on pattern change
    input._maskHandler({ target: input })
  },
  beforeUnmount(el) {
    const input = el.querySelector('input') || el
    if (input && input._maskHandler) {
      input.removeEventListener('input', input._maskHandler)
      delete input._maskHandler
    }
  },
}

export default maskDirective
